import React, { useState } from "react";

import styled from "@emotion/styled";
import classNames from "classnames";

import { activeBorderBottom } from "../../../activeLink";
import Clickable from "../../../Clickable";
import { Link } from "../../../LinkComponent";
import SubNav from "./SubNav";
import { css } from "@emotion/core";
import useNavigationStore from "../../store";

const LinkItemsContainer = styled.div`
    display: none;
    flex-grow: 1;
    height: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    ${({ theme }) => theme.breakpoints.from.normal.css`
                display: flex;
        flex-grow: 0;
        padding: 0;
    `}
`;

const LinkItem = styled(Link)`
    flex-grow: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.blue.toString()};
    font-weight: 500;

    ${({ theme }) => theme.breakpoints.from.normal.css`
        flex-grow: 0;
        padding: 0 0.8vw;
    `}

    ${({ theme }) => theme.breakpoints.from.large.css`
        flex-grow: 0;
        padding: 0 30px;
    `}

    ${({ theme }) => theme.selectors.hover.css`
        color: ${theme.colors.blue.toString()};
    `}

    &:focus {
        > span {
            border-bottom: 4px solid
                ${({ theme }) => theme.colors.blue.toString()};
        }
    }

    ${activeBorderBottom({ size: "4px", target: ".link-text-wrapper" })}
`;

const LinkItemClickable = LinkItem.withComponent(Clickable);

const LinkTextWrapper = styled.span`
    font-size: 16px;
    font-weight: 600;
`;

const StyledActiveSpan = styled.span`
    padding-bottom: 4px;
    ${({ active }) =>
        active &&
        css`
            border-bottom-style: solid;
            border-bottom-width: 4px;
        `};
`;

const SubNavContainer = styled.div`
    flex-grow: 1;
    position: relative;
    flex-direction: column;

    ${({ theme }) => theme.breakpoints.from.normal.css`
        flex-grow: 0;
    `}

    > div {
        visibility: hidden;
    }

    &.active > div {
        visibility: visible;
    }

    ${activeBorderBottom({ size: "4px", target: ".link-text-wrapper" })}
`;

const LinkItems = ({ sections }) => {
    const [open, setOpen] = useState();

    const [activeSection] = useNavigationStore((state) => [
        state.activeSection,
    ]);

    return (
        <LinkItemsContainer>
            {sections.slice(0, -1).map((section, i) => {
                return section.subsections && section.subsections.length > 0 ? (
                    <SubNavContainer
                        key={i}
                        className={classNames({ active: open === i })}
                        onMouseEnter={() => setOpen(i)}
                        onMouseLeave={() => setOpen()}
                        onClick={() => {
                            if (open === i) {
                                setOpen();
                            } else {
                                setOpen(i);
                            }
                        }}
                    >
                        <LinkItemClickable
                            className={classNames({ active: open === i })}
                        >
                            <LinkTextWrapper className="link-text-wrapper">
                                <StyledActiveSpan
                                    active={activeSection === section.name}
                                >
                                    {" "}
                                    {section.name}
                                </StyledActiveSpan>
                            </LinkTextWrapper>
                        </LinkItemClickable>
                        <SubNav subsections={section.subsections} />
                    </SubNavContainer>
                ) : (
                    <LinkItem key={i} to={section.href}>
                        <LinkTextWrapper className="link-text-wrapper">
                            <StyledActiveSpan
                                active={activeSection === section.name}
                            >
                                {section.name}
                            </StyledActiveSpan>
                        </LinkTextWrapper>
                    </LinkItem>
                );
            })}
        </LinkItemsContainer>
    );
};

export default LinkItems;
